import script from "./rec-score-category.vue?vue&type=script&lang=ts&setup=true"
export * from "./rec-score-category.vue?vue&type=script&lang=ts&setup=true"

import "./rec-score-category.vue?vue&type=style&index=0&id=74f2797e&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74f2797e"]])

export default __exports__